const features = [
  { icon: 'ri-flashlight-line', title: '极速更新', desc: '7×24小时全天候内容更新，热点事件第一时间上线，让你永远快人一步吃到最新鲜的瓜。' },
  { icon: 'ri-hd-line', title: '高清画质', desc: '全站视频支持1080P高清播放，自适应码率技术，无论网络环境如何都能流畅在线观看。' },
  { icon: 'ri-smartphone-line', title: '多端适配', desc: '完美适配手机、平板、电脑等全设备，提供独立APP和网页版，随时随地开启吃瓜模式。' },
  { icon: 'ri-shield-check-line', title: '内容审核', desc: '专业编辑团队严格审核每一条视频内容，确保信息真实可靠，拒绝虚假谣言传播。' },
  { icon: 'ri-user-voice-line', title: '投稿有奖', desc: '开放网友投稿通道，独家猛料一经采用即付丰厚稿酬，你的爆料就是下一个头条。' },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-bold mb-4">
            <i className="ri-star-line"></i>
            平台优势
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            为什么选择51吃瓜在线
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            五大核心优势，打造最专业的吃瓜视频平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((f, i) => (
            <div
              key={i}
              className="group bg-background-100 rounded-xl p-6 text-center hover:shadow-md transition-all duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4 rounded-2xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${f.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}